import { render, staticRenderFns } from "./ProfileChangeRankinsPageSize.vue?vue&type=template&id=cfe52de0&scoped=true"
import script from "./ProfileChangeRankinsPageSize.vue?vue&type=script&lang=js"
export * from "./ProfileChangeRankinsPageSize.vue?vue&type=script&lang=js"
import style0 from "./ProfileChangeRankinsPageSize.vue?vue&type=style&index=0&id=cfe52de0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cfe52de0",
  null
  
)

export default component.exports